import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import PlaceholderImage from "../../products/PlaceholderImage";
import solarPanelSytemArchitecture from "../../../assets/smarthome/energySection/solarPanelSytemArchitecture.png";
import energyGraphs from "../../../assets/smarthome/energySection/energyGraphs.png";
import enedisIcon from "../../../assets/smarthome/energySection/bouton_enedis_vert.png";

export default function EnergySection(props) {
  const { textContent, language } = { ...props };

  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container energy-section">
      <div className="container-small">
        <h1 className="title-gradient-black-green">
          {textContent.energySection.title[language]}
        </h1>
      </div>
      <div className={isMobile ? "energy-content-mobile" : "energy-content"}>
        <div className="energy-text">
          <h2 className="h2-bold">
            {
              textContent.energySection.features.items.solarPanels.title[
                language
              ]
            }
          </h2>
          <p>
            {
              textContent.energySection.features.items.solarPanels.description[
                language
              ]
            }
          </p>
        </div>
        {isMobile ? <div className="container-empty-extra-small" /> : null}
        <div className="energy-visual">
          <img src={solarPanelSytemArchitecture} alt="" />
        </div>
        <div className="container-small"></div>
      </div>
      <div className="container-empty-extra-small" />
      {!isMobile ? (
        <div className="energy-content graph">
          <div className="energy-visual">
            <img src={energyGraphs} alt="graphique d'énergie" />
          </div>
          <div className="energy-text">
            <h1
              className={
                screenWidth < 1460
                  ? "title-gradient-black-green-threeLines"
                  : "title-gradient-black-green"
              }
            >
              {
                textContent.energySection.features.items.energyGraphs.title[
                  language
                ]
              }
            </h1>
            <p>
              {
                textContent.energySection.features.items.energyGraphs
                  .description[language]
              }
            </p>
            <div className="container-empty-small" />
            <div className="enedis-content">
              <div className="enedis-icon">
                <img src={enedisIcon} alt="icone Endedis" />
              </div>
              {/* <div className="container-empty-extra-small" /> */}
              <p>
                {
                  textContent.energySection.features.items.enedis.description[
                    language
                  ]
                }
              </p>
            </div>
          </div>

          <div className="container-small" />
        </div>
      ) : (
        <div className="energy-content-mobile graph">
          {/* <div className="container-empty-extra-small" /> */}
          <div className="energy-text graph">
            <h1 className="title-gradient-black-green">
              {
                textContent.energySection.features.items.energyGraphs.title[
                  language
                ]
              }
            </h1>
            <p>
              {
                textContent.energySection.features.items.energyGraphs
                  .description[language]
              }
            </p>
          </div>
          <div className="container-empty-extra-small" />
          <div className="energy-visual">
            <img src={energyGraphs} alt="graphique d'énergie" />
          </div>
          <div className="container-empty-extra-small" />
          <div className="enedis-content">
            <div className="enedis-icon">
              <img src={enedisIcon} alt="icone Endedis" />
            </div>
            {/* <div className="container-empty-extra-small" /> */}
            <p>
              {
                textContent.energySection.features.items.enedis.description[
                  language
                ]
              }
            </p>
          </div>
          <div className="container-small"></div>
        </div>
      )}
    </section>
  );
}
